<div class="container">
  <section class="about">
    <img id="cloud" class="cloud_left" src="../../../assets/img/clouds/cloud.svg" alt="image">
    <img class="country" src="../../../assets/img/countries.svg" alt="image">
    <div class="about-row">
      <img class="about-image" src="../../../assets/img/man-about.svg" alt="image">
      <div class="about-item">
        <span class="about-text_secondary">1</span>
        <div class="about-item-description"><span class="about-item-description-title">  Скачай приложение</span> и
          <span class="about-item-description-title">зарегистрируйся</span>.
          <br> Все, что тебе нужно — смартфон и банковская карта.
        </div>
      </div>

      <div class="about-item">
        <span class="about-text_secondary">2</span>
        <div class="about-item-description"><span class="about-item-description-title">Отсканируй QR код</span> на руле,
          <span class="about-item-description-title">выбери тариф</span> в приложении и <span
            class="about-item-description-title">нажми "Начать поездку"</span>.
          <br> Накатаешься — оставь самокат в синей зоне (в приложении на карте) и заверши поездку. В некоторых городах
          синей зоны нет и самокат можно оставить в любой точке.
        </div>
      </div>

      <div class="about-item">
        <span class="about-text_secondary">3</span>
        <div class="about-item-description"><span class="about-item-description-title">Есть вопросы?</span> <br>
          Внимательно прочитай правила использования и инструкции ниже. Если не нашел ответа, пиши в чат поддержки в
          приложении.Тебе оперативно помогут.
        </div>
      </div>
    </div>
  </section>
</div>
